import { useEffect } from 'react'

import useReduxAction from '@hooks/useReduxAction'

import useCampaignPortalSync from '@hooks/useCampaignPortalSync'
import useCurrentUser from '@hooks/useCurrentUser'

import type { CampaignPortalSyncModel } from '@models/types'

import type { ModuleState } from '@redux/modules/module'
import type { ModalCallbacks } from '../index'

type useCampaignPortalSyncDetailsModalParams = {
  callbacks: ModalCallbacks,
  campaignPortalSync: CampaignPortalSyncModel,
  requestOptions?: object,
}

const useCampaignPortalSyncDetailsModal = (params: useCampaignPortalSyncDetailsModalParams) => {
  const { callbacks, campaignPortalSync: initEntity, requestOptions: campaignPortalSyncRequestOptions } = params

  const { isAdmin } = useCurrentUser()

  useReduxAction(
    'campaignPortalSyncs',
    'loadCampaignPortalSync',
    {
      entityId: initEntity.id,
      ...campaignPortalSyncRequestOptions,
    },
    [initEntity.id],
    {
      dispatchAction: (action, requestOptions) => action(initEntity.id, requestOptions),
      shouldPerformFn: ({ loading }: ModuleState) => !!initEntity.id && !loading && isAdmin,
    },
  )

  const campaignPortalSyncPayload = useCampaignPortalSync(initEntity)

  const {
    callbacks: {
      campaignPortalSyncFetchLog,
    },
    campaignPortalSync,
  } = campaignPortalSyncPayload

  // Conditional fetch_log request
  useEffect(() => {
    if (campaignPortalSync.sync_type === 'export' && !campaignPortalSync.log_data && isAdmin){
      const { fetchLog } = callbacks || {}

      const fetchLogPayload = {
        callbacks: {
          action: campaignPortalSyncFetchLog,
        },
        requestOptions: campaignPortalSyncRequestOptions,
      }

      // @ts-expect-error TS2345
      fetchLog(fetchLogPayload)
    }
  }, [campaignPortalSync.id])

  return {
    campaignPortalSyncPayload,
  }
}

export default useCampaignPortalSyncDetailsModal
